import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 10000,
  withCredentials: true,
});

// Get all notifications for the current user
export const getNotifications = async () => {
  try {
    const response = await api.get('/user/notifications');
    return {
      success: true,
      notifications: response.data.notifications || [],
      unreadCount: response.data.unreadCount || 0,
    };
  } catch (error) {
    return {
      success: false,
      notifications: [],
      unreadCount: 0,
    };
  }
};

// Get unread count only (lightweight, for the bell badge)
export const getUnreadCount = async () => {
  try {
    const response = await api.get('/user/notifications/unread-count');
    return {
      success: true,
      unreadCount: response.data.unreadCount || 0,
    };
  } catch (error) {
    return { success: false, unreadCount: 0 };
  }
};

// Mark a single notification as read
export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await api.put(`/user/notifications/${notificationId}/read`);
    return { success: true, notification: response.data.notification };
  } catch (error) {
    return { success: false };
  }
};

// Mark all notifications as read
export const markAllNotificationsAsRead = async () => {
  try {
    await api.put('/user/notifications/read-all');
    return { success: true };
  } catch (error) {
    return { success: false };
  }
};
